import axios from 'axios'
import Qs from 'qs'
import router from './router'
import ElementUI from 'element-ui'
import mobileAxios from '@/components/Mobile/mobile_axios.js'
// 导入Token过期检测工具
import { stopTokenExpirationCheck, showExpiredDialog } from '@/utils/tokenExpiration'

// 添加请求拦截器
axios.interceptors.request.use(function(config) {
    return config
}, function(err) {
    // 对请求错误做些什么
    return Promise.reject(err)
})

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
    if (response.data.status === 401) {
        // Token过期或未授权，停止过期检测
        stopTokenExpirationCheck()
        // 显示统一的过期对话框
        showExpiredDialog()
    } else if (response.data.status === 403) {
    //  router.push({ path: 'unauth' })
        ElementUI.Message.error(`无权限访问！`)
    } else if (response.data.status === 404) { // 错误
    //  ElementUI.Message.error(response.data.msg)
        router.push({ path: `S404` })
    }
    return response.data
}, function(err) {
    if (err && err.response) {
        switch (err.response.status) {
        case 400: err.message = `请求错误(400)`; break
        case 401:
            err.message = `未授权，请重新登录(401)`
            // Token过期或未授权，停止过期检测
            stopTokenExpirationCheck()
            // 显示统一的过期对话框
            showExpiredDialog()
            break
        case 403: err.message = `拒绝访问(403)`; break
        case 404: err.message = `请求出错(404)`; break
        case 408: err.message = `请求超时(408)`; break
        case 500: err.message = `服务器错误(500)`; break
        case 501: err.message = `服务未实现(501)`; break
        case 502: err.message = `网络错误(502)`; break
        case 503: err.message = `服务不可用(503)`; break
        case 504: err.message = `网络超时(504)`; break
        case 505: err.message = `HTTP版本不受支持(505)`; break
        default: err.message = `连接出错(${err.response.status})!`
        }
    } else {
    // router.push({ path: 'Login',query:{code:'9999'} })
        return Promise.reject(`连接服务器失败!`)
    }
    return Promise.reject(err.response.data)
})

export default {
    all: (...reqests) => {
        return new Promise((resolve, reject) => {
            axios.all(reqests).then(axios.spread(function(...responses) {
                resolve(responses)
            })).catch(e => {
                reject(e)
            })
        })
    },
    post: (url, data, config, showloading = true) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            let loading = null
            if (showloading) {
                loading = ElementUI.Loading.service({
                    lock: true,
                    // text: 'loading',
                    spinner: `el-icon-loading`,
                    background: `rgba(0, 0, 0, 0)`
                })
            }

            axios.post(url, data, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config))
                .then((response) => {
                    if (showloading) {
                        loading.close()
                    }
                    if (_.has(response, `status`)) {
                        if (response.status === 200) {
                            return resolve(response.data)
                        } else {
                            return reject(response.msg)
                        }
                    } else {
                        resolve(response)
                    }
                }).catch(e => {
                    if (showloading) {
                        loading.close()
                    }
                    if (e && e.data && e.status == `600`) {
                        ElementUI.Message.error(e.data && e.data.detail)
                    } else if (e && e.data) {
                        ElementUI.Notification.error({
                            title: `错误`,
                            message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                        })
                    }
                    return reject(e)
                })
        })
    },
    postpagination: (url, data, config, showloading = true) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            let loading = null
            if (showloading) {
                loading = ElementUI.Loading.service({
                    lock: true,
                    // text: 'loading',
                    spinner: `el-icon-loading`,
                    background: `rgba(0, 0, 0, 0)`
                })
            }

            axios.post(url, data, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config))
                .then((response) => {
                    if (showloading) {
                        loading.close()
                    }
                    if (_.has(response, `status`)) {
                        if (response.status === 200) {
                            return resolve(response)
                        } else {
                            return reject(response.msg)
                        }
                    } else {
                        resolve(response)
                    }
                }).catch(e => {
                    if (showloading) {
                        loading.close()
                    }
                    if (e && e.data && e.status == `600`) {
                        ElementUI.Message.error(e.data && e.data.detail)
                    } else if (e && e.data) {
                        ElementUI.Notification.error({
                            title: `错误`,
                            message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                        })
                    }
                    return reject(e)
                })
        })
    },
    get: (url, params, config) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                // text: 'loading',
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            axios.get(url, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config, { params: params })).then((response) => {
                loading.close()
                if (_.has(response, `status`)) {
                    if (response.status === 200) {
                        return resolve(response.data)
                    } else {
                        return reject(response.msg)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                loading.close()
                if (e && e.data && e.status == `600`) {
                    ElementUI.Message.error(e.data && e.data.detail)
                } else if (e && e.data) {
                    ElementUI.Notification.error({
                        title: `错误`,
                        message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                    })
                }
                return reject(e)
            })
        })
    },
    getNoloading: (url, params, config) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            axios.get(url, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config, { params: params })).then((response) => {
                if (_.has(response, `status`)) {
                    if (response.status === 200) {
                        return resolve(response.data)
                    } else {
                        return reject(response.msg)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                if (e && e.data && e.status == `600`) {
                    ElementUI.Message.error(e.data && e.data.detail)
                } else if (e && e.data) {
                    ElementUI.Notification.error({
                        title: `错误`,
                        message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                    })
                }
                return reject(e)
            })
        })
    },
    put: (url, data, config) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            const loading = ElementUI.Loading.service({
                lock: true,
                // text: 'loading',
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            axios.put(url, data, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config)).then((response) => {
                loading.close()
                if (_.has(response, `status`)) {
                    if (response.status === 200) {
                        return resolve(response.data)
                    } else {
                        return reject(response.msg)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                loading.close()
                if (e && e.data && e.status == `600`) {
                    ElementUI.Message.error(e.data && e.data.detail)
                } else if (e && e.data) {
                    ElementUI.Notification.error({
                        title: `错误`,
                        message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                    })
                }
                return reject(e)
            })
        })
    },
    delete: (url, params, config) => {
        return new Promise((resolve, reject) => {
            let clientIp = sessionStorage.getItem(`clientIp`)
            if (!clientIp || clientIp === `undefined` || clientIp === `null`) {
                clientIp = ``
            }

            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            const loading = ElementUI.Loading.service({
                lock: true,
                // text: 'loading',
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            axios.delete(url, Object.assign({ headers: {
                'Authorization': authorization,
                'clientIp': clientIp
            },
            emulateJSON: true }, config, { params: params })).then((response) => {
                loading.close()
                if (_.has(response, `status`)) {
                    if (response.status === 200) {
                        return resolve(response.data)
                    } else {
                        return reject(response.msg)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                loading.close()
                if (e && e.data && e.status == `600`) {
                    ElementUI.Message.error(e.data && e.data.detail)
                } else if (e && e.data) {
                    ElementUI.Notification.error({
                        title: `错误`,
                        message: e.data && `${e.data.detail}(timestamp:${e.data.timestamp})`
                    })
                }
                return reject(e)
            })
        })
    },
    post_doc: (url, data) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            axios.post(`${axios.docservice_base_url}/${url}`, Qs.stringify(data, { indices: false })
                , { headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) } })
                .then((response) => {
                    loading.close()
                    if (_.has(response, `status`)) {
                        if (response.status === `success`) {
                            return resolve(response.data)
                        } else {
                            return reject(response)
                        }
                    } else {
                        resolve(response)
                    }
                }).catch(e => {
                    loading.close()
                    ElementUI.Notification.error({
                        title: `错误`,
                        message: e
                    })
                    return reject(e)
                })
        })
    },
    get_doc: (url, data, config) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                // text: 'loading',
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            axios.get(`${axios.docservice_base_url}/${url}`,
                { headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: data }).then((response) => {
                loading.close()
                if (_.has(response, `status`)) {
                    if (response.status === `success`) {
                        return resolve(response.data)
                    } else {
                        return reject(response)
                    }
                } else {
                    resolve(response)
                }
            }).catch(e => {
                loading.close()
                ElementUI.Notification.error({
                    title: `错误`,
                    message: e
                })
                return reject(e)
            })
        })
    },
    export_excel: (data, fileName) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }

            axios.post(`/api/Operation/Home/ExcelFile`, data, {
                headers: {
                    'Authorization': authorization
                },
                responseType: `blob`
            }).then((response) => {
                loading.close()
                if (response) {
                    const url = window.URL.createObjectURL(response)
                    const link = document.createElement(`a`)
                    link.href = url
                    link.setAttribute(`download`, fileName)
                    document.body.appendChild(link)
                    link.click()
                    return resolve()
                } else {
                    return reject()
                }
            }).catch(e => {
                loading.close()
                ElementUI.Notification.error({
                    title: `错误`,
                    message: e
                })
                return reject(e)
            })
        })
    },
    export_excel_Extradata: (exportUrl, data, fileName, title) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            // api/Operation/Home/ExcelFile_YaoYing
            axios.post(`${exportUrl}?title=${title}`, data, {
                headers: {
                    'Authorization': authorization
                },
                responseType: `blob`
            }).then((response) => {
                loading.close()
                if (response) {
                    const url = window.URL.createObjectURL(response)
                    const link = document.createElement(`a`)
                    link.href = url
                    link.setAttribute(`download`, fileName)
                    document.body.appendChild(link)
                    link.click()
                    return resolve()
                } else {
                    return reject()
                }
            }).catch(e => {
                loading.close()
                ElementUI.Notification.error({
                    title: `错误`,
                    message: e
                })
                return reject(e)
            })
        })
    },
    export_excel_Template: (exportUrl, data, fileName, title) => {
        return new Promise((resolve, reject) => {
            const loading = ElementUI.Loading.service({
                lock: true,
                spinner: `el-icon-loading`,
                background: `rgba(0, 0, 0, 0)`
            })
            let token = sessionStorage.getItem(`token`)
            let authorization = `bearer ${token}`
            if (!token || token === `undefined` || token === `null`) {
                authorization = undefined
            }
            // api/Operation/Home/ExcelFile_YaoYing
            axios.post(`${exportUrl}`, data, {
                headers: {
                    'Authorization': authorization
                },
                responseType: `blob`
            }).then((response) => {
                loading.close()
                if (response) {
                    const url = window.URL.createObjectURL(response)
                    const link = document.createElement(`a`)
                    link.href = url
                    link.setAttribute(`download`, fileName)
                    document.body.appendChild(link)
                    link.click()
                    return resolve()
                } else {
                    return reject()
                }
            }).catch(e => {
                loading.close()
                ElementUI.Notification.error({
                    title: `错误`,
                    message: e
                })
                return reject(e)
            })
        })
    },
    mobile_get: mobileAxios.mobile_get,
    mobile_post: mobileAxios.mobile_post
}



// WEBPACK FOOTER //
// ./src/myaxios.js